import { render, staticRenderFns } from "./assessment.vue?vue&type=template&id=6ae3166a&scoped=true"
import script from "./assessment.vue?vue&type=script&lang=js"
export * from "./assessment.vue?vue&type=script&lang=js"
import style0 from "./assessment.vue?vue&type=style&index=0&id=6ae3166a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae3166a",
  null
  
)

export default component.exports